import App from "@bloglovin/inspire-engine/App";
import { environmentByApp } from "%/helpers/db-app-environment";

export function installedDbApps() {
  return window.blclient?.data?.dbApps ?? {};
}

export async function bootInstalledDbApps() {
  const catalog = installedDbApps();
  const appNames = Object.keys(catalog);
  const environment = environmentByApp(catalog);
  for (let i = 0; i < appNames.length; i++) {
    const appName = appNames[i];
    try {
      await App.create(appName, Number(catalog[appName]?.releaseId) || 0, environment);
    } catch (error) {
      const message = String(error?.message ?? error);
      if (!message.includes("already booted")) {
        // eslint-disable-next-line no-console
        console.error(`bootInstalledDbApps: "${appName}" failed to boot — ${message}`);
      }
    }
  }
}
